import { designSystemColors, otherColors } from '@klv/shared/styles/colors';

const moreCard = {
  borderColor: designSystemColors.poppy,
  shadowColor: otherColors.shadowColor,
};

export default moreCard;
